import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@components/mantine";
import { forwardRef } from "react";
import { useSourceIdentityContext } from "./SourceIdentityContext.js";
export var SourceIdentityCustomVariant = /*#__PURE__*/ forwardRef(function(_param, ref) {
    var children = _param.children, _trackingHandler = _param.trackingHandler, props = _object_without_properties(_param, [
        "children",
        "trackingHandler"
    ]);
    var getStyles = useSourceIdentityContext().getStyles;
    return /*#__PURE__*/ _jsx(Box, _object_spread_props(_object_spread({
        ref: ref,
        flex: 1
    }, getStyles("root"), props), {
        children: children
    }));
});
SourceIdentityCustomVariant.displayName = "@resourceIdentity/source/SourceIdentity/CustomVariant";

//# sourceMappingURL=SourceIdentityCustomVariant.js.map